<template>
<div class="inventory-manage">
    <div class="nav-bread">
        <router-link class="link-item" :to="{'name': 'inventoryinfo'}">库存信息</router-link>
        <router-link class="link-item" v-if="userTypeNum == 0" :to="{'name': 'inventorywarnning'}">库存预警</router-link>
        <router-link class="link-item" v-if="userTypeNum != 0 && userTypeNum == 1" :to="{'name': 'newinventoryorder'}">新建入库单</router-link>
        <router-link class="link-item" v-if="userTypeNum != 0" :to="{'name': 'checkinventory'}">盘点库存</router-link>
    </div>
    <router-view></router-view>
</div>
</template>

<script>
import {
    mapGetters,
    mapMutations
} from 'vuex';
export default {
    data() {
        return {

        }
    },
    computed: {
        ...mapGetters(['user', 'userTypeNum'])
    }
}
</script>

<style scoped>
.inventory-manage {
    margin: 0 auto;
    background-color: #f1f1f1;
}

.inventory-manage .nav-bread {
    width: 90%;
    margin: 0 auto;
    height: 50px;
    background-color: #f1f1f1;
    font-family: PingFangSC-Regular, Microsoft YaHei;
    padding-top: 8px;
}

.inventory-manage .nav-bread>.link-item {
    display: inline-block;
    padding: 10px 20px;
    text-decoration: none;
    font-size: 18px;
    color: #2a2a2a;
    line-height: 30px;
    border-radius: 8px 8px 0 0;
}

.inventory-manage .router-link-active {
    color: #000 !important;
    background-color: #d2f5e8;
}
</style>



// WEBPACK FOOTER //
// src/pages/inventoryManage/InventoryManage.vue